$(function () {
    "use strict";

    /*------ MENU Fixed ------*/
    $(window).scroll(function () {
        var $scroll = $(window).scrollTop();
        var $navbar = $(".navbar");
        if ($scroll > 100) {
            $navbar.addClass("scroll-nav");
        } else {
            $navbar.removeClass("scroll-nav");
        }
    });

    $('.hamburger').click(function(){
        $('.navbar-left').toggleClass('show');

    });
    $('#down').click(function(){
        $('.shop-down').toggleClass('down');

    });
//     $('ul.nav.navbar-nav.navbar-left>li').click(function(){
//         $(this).slideToggle('');

//     });
     $('ul.submenu>li').click(function(){
        $(this).toggleClass('down-drop-child').siblings().removeClass('down-drop-child');

    });
    $(document).ready(function() {
        $('.banner-slider').owlCarousel({
          autoplay: true,
          items: 1,
          nav: false,
          dots:true,
          loop: true,
          thumbs: false,
//           animateOut: 'slideOutUp',
//           animateIn: 'slideInUp',
          autoplayTimeout: 5000,
          autoplayHoverPause: false
        });
     
      });
      $('.product-carousel').owlCarousel({
        loop: true,
        dots: false,
        nav: false,
        margin: 0,
        items: 1,
        thumbs: true,
        thumbImage: true,
        thumbContainerClass: 'owl-thumbs',
        thumbItemClass: 'owl-thumb-item'
    });
    $(document).ready(function() {
        $('.minus').click(function () {
            var $input = $(this).parent().find('input');
            var count = parseInt($input.val()) - 1;
            count = count < 1 ? 1 : count;
            $input.val(count);
            $input.change();
            return false;
        });
        $('.plus').click(function () {
            var $input = $(this).parent().find('input');
            $input.val(parseInt($input.val()) + 1);
            $input.change();
            return false;
        });
    });
  $(".banner-btn").click(function() {
    $('html, body').animate({
        scrollTop: $("#shop-catsec").offset().top
    }, 2000);
});
});



